import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "col-2" };
const _hoisted_2 = { class: "col-2" };
const _hoisted_3 = { class: "col-2" };
const _hoisted_4 = { class: "col-2" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "col-2" };
import { onMounted, ref, watch } from 'vue';
import LedDebug from './LedDebug.vue';
import Icon from '@/components/UI/Icon/Icon.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        status: null
    },
    emits: ["updateLaser", "updateButton"],
    setup(__props, { emit }) {
        const props = __props;
        const laserStatesLocal = ref([]);
        onMounted(() => {
            laserStatesLocal.value = props.status;
        });
        watch(() => props.status, (newStatus) => {
            laserStatesLocal.value = newStatus;
        });
        function updateLaser(index, value) {
            var _a;
            if (laserStatesLocal.value[index]) {
                laserStatesLocal.value[index].active = value == 'on';
            }
            const laserStatusArray = ((_a = laserStatesLocal.value) === null || _a === void 0 ? void 0 : _a.map(l => l.active ? 'on' : 'off')) || [];
            emit('updateLaser', { name: 'laser', value: JSON.stringify(laserStatusArray) });
        }
        function updateLaserBlocked(index, blocked) {
            if (laserStatesLocal.value[index]) {
                laserStatesLocal.value[index].blocked = blocked;
            }
            emit('updateButton', { name: 'laser_' + index, value: blocked ? 'released' : 'clicked' });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(laserStatesLocal.value, (laser, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "row",
                        key: `hole_${index}`
                    }, [
                        _createElementVNode("div", _hoisted_1, " Laser " + _toDisplayString(index), 1),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(LedDebug, {
                                id: 'laser_' + index,
                                status: laser.active ? 'on' : 'off',
                                onUpdateLed: ($event) => (updateLaser(index, $event['value']))
                            }, null, 8, ["id", "status", "onUpdateLed"])
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(Icon, {
                                name: laser.active ? 'lightbulb' : 'times-circle',
                                cssstyle: 'color:' + (laser.active ? '#00FF00' : '#FF0000')
                            }, null, 8, ["name", "cssstyle"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                class: "btn btn-link",
                                onClick: ($event) => (updateLaserBlocked(index, !laser.blocked))
                            }, [
                                _createVNode(Icon, {
                                    name: laser.blocked ? 'door-closed' : 'door-open',
                                    cssstyle: 'color:' + (laser.blocked ? '#FF0000' : '#00FF00')
                                }, null, 8, ["name", "cssstyle"])
                            ], 8, _hoisted_5)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(Icon, {
                                name: laser.disabled ? 'ban' : 'check',
                                cssstyle: 'color:' + (laser.disabled ? '#00FF00' : '#FF0000')
                            }, null, 8, ["name", "cssstyle"])
                        ])
                    ]));
                }), 128))
            ]));
        };
    }
});
